import { Navigate } from "react-router";
import { useMe, usePermissions } from "src/context/MeContext";
import { useNavigation } from "src/context/NavigationContext";


/**
 * Redirects to the first accessible settings page based on user permissions.
 * On mobile, returns null to show the settings menu instead of redirecting.
 * This ensures users always land on a page they have access to.
 */
export default function SettingsDefaultRedirect() {
  const { canRead } = usePermissions();
  const { isMobile } = useNavigation();
  const me = useMe();
  const brandTheme = me.organization?.brandTheme ?? "TIERZERO";
  const isPureRootly = brandTheme === "ROOTLY" || brandTheme === "ROOTLY_COBRAND";

  // On mobile, don't redirect - show the settings menu instead
  if (isMobile) {
    return null;
  }

  // Check scopes in order of preference and redirect to first accessible page
  // Order: Integrations, Feature Enablement, Teams, Usage
  if (canRead("integrations")) {
    return <Navigate to="/settings/integrations" replace />;
  }

  if (!isPureRootly && canRead("feature_enablement")) {
    return <Navigate to="/settings/features" replace />;
  }

  if (canRead("teams")) {
    return <Navigate to="/settings/teams" replace />;
  }

  if (!isPureRootly && canRead("billing")) {
    return <Navigate to="/settings/usage" replace />;
  }

  // Fallback: redirect to chat if no settings access (shouldn't happen if left nav logic is correct)
  return <Navigate to="/chat" replace />;
}
